// extracted by mini-css-extract-plugin
module.exports = {"companyNews":"B3ld","headerWrap":"B3kv","headerLink":"B3kx","nav":"B3kz","button":"B3d3","disabled":"B3ib","slider":"B3h3"};